export default __webpack_public_path__ + "64fe220e11aa197d7758941cb3a2466a.png";